import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var externalTrainingListRes;
export const externalTrainingListTodo = createAsyncThunk('externalTrainingList', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/view_external_training_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return externalTrainingListRes = res.data
    } catch (error) {
        return externalTrainingListRes = error.response.data
    }
})


const externalTrainingListSlice = createSlice({
    name: 'externalTrainingList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(externalTrainingListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('externalTrainingList', state.data)
            }
        });
        builder.addCase(externalTrainingListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default externalTrainingListSlice.reducer; 